// Компонент группы радио-кнопок

import type { RadioGroupProps } from '../../types';
import './Input.css';

export function RadioGroup<T extends string>({
  label,
  value,
  onChange,
  options,
  tooltip,
}: RadioGroupProps<T>) {
  const handleChange = (newValue: T) => {
    onChange(newValue);
  };

  return (
    <div className="radio-group" title={tooltip}>
      <span className="radio-group__label">{label}</span>
      <div className="radio-group__options">
        {options.map((option) => (
          <label key={String(option.value)} className="radio-group__option">
            <input
              type="radio"
              className="radio-group__input"
              name={label}
              value={String(option.value)}
              checked={value === option.value}
              onChange={() => handleChange(option.value)}
            />
            <span className="radio-group__text">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
